import addFileProviderOrchestrator from './addFileProvider';
import removeFileProviderOrchestrator from './removeFileProvider';
import { removeAndAddFileProvider } from '../actions/publicActions';
import { FileProviderType } from '../utils/constants';
import getProviderBrandName from '../utils/getProviderBrandName';
import { confirm, DialogResponse } from 'owa-confirm-dialog';
import { format } from 'owa-strings';
import strings from 'owa-strings/owa-mail-strings';
import { orchestrator } from 'satcheljs';

orchestrator(removeAndAddFileProvider, actionMessage => {
    removeAndAddFileProviderOrchestrator(actionMessage.providerType);
});

export default async function removeAndAddFileProviderOrchestrator(providerType: FileProviderType) {
    const providerDisplayName = getProviderBrandName(providerType);

    try {
        await removeFileProviderOrchestrator(providerType);
        const response: DialogResponse = await askUserForAddingProvider(providerDisplayName);
        if (response === DialogResponse.ok) {
            await addFileProviderOrchestrator(providerType);
        }
    } catch (error) {
        /* Ignore the error */
    }
}

function askUserForAddingProvider(providerDisplayName: string): Promise<DialogResponse> {
    return confirm(
        strings.CouldNotConnectToAccountTitleText,
        format(strings.ErrorConnectingToProviderDescriptionText, providerDisplayName),
        false
    );
}
